import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListPlanComponent } from './list-plan/list-plan.component';

const routes: Routes = [
  {
    path: '',
    component: ListPlanComponent,
  },
  { path: '', pathMatch: 'full', redirectTo: 'catalog/plan' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlanRoutingModule { }
